import Evaluator from './Evaluator.js'
import AsyncSyncEvaluatorFactory from './AsyncSyncEvaluatorFactory.js'

// The default factory
const DefaultFactory = new AsyncSyncEvaluatorFactory()

export default class AsyncEvaluator {

  constructor( conditionModel, factory ) {
    this.model = conditionModel
    this.factory = factory
  }

  /**
   * Evaluates the condition ayn
   * @param {Object} context 
   * @returns a Promise that will resolve to true, false or null
   */
  async satisfies( context ) {
    return null
  }

  /**
 * Evaluates Async conditions to determine the state of the context. The
 * answer will be either true, false or null. Null mean that the information
 * in the context was not enough to answer the questions supplied in the condition.
 * @param {ConditionModel|AsyncEvaluator} condition The root level condition model or
 * an AsyncEvaluator built from one
 * @param {Object} context The context containing the information to evaluate.
 * Use Context.getTarget() and other methods to access the values. 
 * @param {Factory} [context.conditionEvaluatorFactory] An optional factory to use. If not supplied, the
 * default AsyncEvaluatorFactory will be used
 * @returns A Promise which will resolve to true, false or null.
 */
  static satisfies( condition, context ) {
    let evaluator
    const factory = context.conditionEvaluatorFactory || DefaultFactory
    if ( condition instanceof AsyncEvaluator || condition instanceof Evaluator ) {
      evaluator = condition
    } else {
      evaluator = factory.create( condition, factory )
    } 
    if ( evaluator == null ) {
      throw new Error( 'An AsyncEvaluator does not exist for ', condition )
    }
    const v = evaluator.satisfies( context )
    if ( v == null || typeof v === 'boolean' ) {
      return Promise.resolve( v )
    }
    if ( typeof v.then === 'function' ) {
      return v
    }
    // unknown types are treated as unknown/null
    return Promise.resolve( null )
  }

  static createEvaluator( condition, factory = DefaultFactory ) {
    return factory.create( condition, factory )
  }
}
